export default __webpack_public_path__ + "static/media/login_bg3.2138b019.jpg";